import React, { useEffect } from 'react';

const Page404 = () => {
  useEffect(() => {
    document.title = 'Not Found';
  }, []);

  return (
    <div className="utility-page-wrap">
      <div className="utility-page-content">
        <img
          src="https://d3e54v103j8qbb.cloudfront.net/static/page-not-found.211a85e40c.svg"
          alt=""
        />
        <h2>404 Sidan hittades inte</h2>
        <div className="text-block-2">
          Kolla att URL:en stämmer eller gå tillbaka till{' '}
          <a href="/" id="Trafikbevakning.com">
            TrafikBevakning.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Page404;
